













import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.building.constructionYear"
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        constructionYear: function(): string|null {
            const constructYear = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(constructYear) {
                return this.$store.getters["FormModule/getValue"](this.pathInStore);
            }
            return "";
        },
    },
    methods: {
        updateValue: function(constructionYear: number): void {
            if (constructionYear == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": constructionYear});
            }
        }
    }
});

